<template>
  <el-tabs v-model="activeName" @tab-click="handleClick" style="height: 100%;">
    <el-tab-pane label="发布通知" name="first" style="height: 100%;">
      <SendNoticeFirst v-if="activeName == 'first'"></SendNoticeFirst>
    </el-tab-pane>
    <el-tab-pane name="second" style="height: 100%;">
      <span slot="label">接收通知 <el-badge is-dot class="item" v-show="$store.state.whetherNewNoticeCharge" /></span>
      <withdrawalRecordSPage v-if="activeName == 'second'"></withdrawalRecordSPage>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import SendNoticeFirst from "./SendNoticeList/SendNoticeListT.vue";
import withdrawalRecordSPage from "./receivelist/receivelistT.vue";
export default {
  // 我的账户查询
  name: "noticeAgents",
  data() {
    return {
      activeName: "first"
    };
  },
  components: {
    SendNoticeFirst,
    withdrawalRecordSPage
  },
  created() {
    this.$store.state.loaction = "/selects/noticeAgents";
  },
  methods: {
    handleClick(tab, event) {
      // console.log(event);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/selects/noticeAgents.vue